/*global searchFilter */
const filter = {
	el: {
		body: document.body,
		modal: document.querySelector('.modal'),
		filterFormModal: document.querySelectorAll('.js-filter-modal')
	},

	events() {
		this.el.filterFormModal.forEach(el => el.addEventListener('submit', e => {
			e.preventDefault()
			searchFilter.fxFilterResults(e.currentTarget)
		}))
	},

	init() {
		this.events()
	}
}

filter.init()